export default class AutocompleteLocalSearch {

  constructor (data, actionPayload, key) {
    this.data = data && Array.isArray(data) ? data : []
    this.payload = actionPayload || {}
    this.key = key || ''
  }

  /**
   * Takes a set of data models and transforms it into a label-value object that can be used in
   * autocomplete field
   */
  formatOptions () {
    // Get active codes data, where codes : Series, Locations, Sets, Free fields etc.
    let resutantData = this.data.filter(r => r.active !== false)
    if (!resutantData || resutantData.length <= 0) return []
    return resutantData.map(v => {
      if (v.code && v.name) {
        if (this.key) return { label: `${v.code} - ${v.name}`, [this.key]: v.id }
        return { label: `${v.code} - ${v.name}`, value: v.id }
      } else if (v.meta_name) {
        return {label: v.meta_name, value: v.id}
      } else if (!v.code && !v.meta_name && v.name) {
        return { label: v.name, value: v.id }
      } else {
        return { label: v.code, value: v.id }
      }
    })
  }

  /**
   * Creates a searchable string from the values of properties defined in payload.searchableFields
   */
  createSearchableString () {
    // Get active codes data, where codes : Series, Locations, Sets, Free fields etc.
    let resutantData = this.data.filter(r => r.active !== false)
    if (!resutantData || resutantData.length <= 0) return []
    return resutantData.map(datapoint => {
      let searchableString = ''
      this.payload.searchableFields.forEach(searchableField => {
        if (datapoint[searchableField]) {
          searchableString = searchableString + datapoint[searchableField] + ' '
        }
      })
      return searchableString.trim().toLowerCase().replace(/-/g, '')
    })
  }

  createOptions () {
    return {
      searchable: this.createSearchableString(),
      opts: this.formatOptions()
    }
  }
}
